import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "../../src/styles.css";
import { FormatQuote } from "@mui/icons-material";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { appreciations } from "../utils/constants";
import VOCModal from "./VOCModal";

export default function Testimonials() {
  const [openVOCModal, setOpenVOCModal] = useState(false);

  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        pagination={true}
        modules={[EffectCoverflow, Autoplay]}
        className="mySwiper"
      >
        {appreciations.map((appreciation, index) => (
          <SwiperSlide key={appreciation?.id} style={{ padding: 0 }}>
            <Card
              id="Card_comp"
              sx={{
                padding: 1,
                height: "100%",
              }}
              elevation={3}
            >
              <CardHeader
                avatar={<Avatar src="RIVA_new.png" />}
                title={appreciation?.author}
                subheader={appreciation?.date}
                style={{ padding: 5 }}
              />
              <CardContent style={{ padding: 5 }}>
                <FormatQuote fontSize="medium" />
                <Typography fontSize={11.5}>{appreciation?.content}</Typography>
              </CardContent>
              {/* <CardActions disableSpacing>
                <IconButton aria-label="add to favorites">
                  <ThumbUp />
                </IconButton>
                <IconButton aria-label="add to favorites">
                  <Favorite />
                </IconButton>
              </CardActions> */}
              {/* <div className="wave"></div> */}
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      {openVOCModal && (
        <VOCModal
          open={openVOCModal}
          onClosingVOCModal={() => {
            setOpenVOCModal(false);
          }}
        />
      )}
    </>
  );
}
